/**
 * The third-party TOOLS behind the platform are trade secrets. Anything
 * LLM-authored or backend-authored can name them, so every read-only render of
 * that content passes through this scrub. Order matters: longest match first.
 *
 * AI model and provider names (Claude, GPT, Gemini, Kimi, ...) are deliberately
 * NOT scrubbed — the model picker names them openly and that is intended.
 */
const VENDOR_TERM_REPLACEMENTS: Array<[RegExp, string]> = [
  [/scrapecreators\.com/gi, "social-scraper"],
  [/scrape[\s_-]?creators/gi, "Social Scraper"],
  [/perplexity\.ai/gi, "search-engine"],
  [/perplexity[\s_-]?search/gi, "web search"],
  [/perplexity/gi, "web search"],
];

export function scrubVendorTerms(text: string): string {
  let out = text;
  for (const [pattern, replacement] of VENDOR_TERM_REPLACEMENTS) {
    out = out.replace(pattern, replacement);
  }
  return out;
}

export function scrubVendorTermsDeep<T>(value: T): T {
  if (typeof value === "string") return scrubVendorTerms(value) as T;
  if (Array.isArray(value)) return value.map((item) => scrubVendorTermsDeep(item)) as T;
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, entry]) => [
        key,
        scrubVendorTermsDeep(entry),
      ]),
    ) as T;
  }
  return value;
}
